import styled from 'styled-components'
import { Panel } from 'ui/components/Panel'

const TablePanel = styled(Panel)`
  margin-bottom: 70px;
`

export const s = { TablePanel }
